import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'

import { getHelpdeskParams } from 'app/auth/state/actions'
import { Time } from '@carsys/enums/time'

const useGetHelpdeskParams = () => {
  const dispatch = useDispatch()
  return useQuery(
    ['GET', 'HELPDESK', 'PARAMS'],
    async () => {
      const { Data } = await dispatch(getHelpdeskParams())

      return Data
    },
    {
      staleTime: Time.Minute * 10
    }
  )
}

export default useGetHelpdeskParams
